export const API_URL = import.meta.env.VITE_API_URL ?? "http://localhost:4000";

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${API_URL}${path}`, {
    ...init,
    headers: { "Content-Type": "application/json", ...(init?.headers ?? {}) }
  });
  const body = await response.json();
  if (!response.ok) throw Object.assign(new Error(body.error ?? "REQUEST_FAILED"), { body, status: response.status });
  return body as T;
}
